import React, {ReactNode} from 'react';
import styled from 'styled-components';

const Body = styled.div`
	flex: 1 1 auto;
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

type DrawerBodyProps = {
	children: ReactNode;
};

const DrawerBody = ({children}: DrawerBodyProps): JSX.Element => {
	return <Body>{children}</Body>;
};

export default DrawerBody;
